import optionControls from '../theme/icons/option-controls.svg'
import optionLoop from '../theme/icons/option-loop.svg'
import optionMute from '../theme/icons/option-mute.svg'
import optionPlay from '../theme/icons/option-play.svg'
import optionNoTracking from '../theme/icons/option-notracking.svg'
import positionAuto from '../theme/icons/position-auto.svg'
import positionLeft from '../theme/icons/position-left.svg'
import positionRight from '../theme/icons/position-right.svg'
import positionCenter from '../theme/icons/position-center.svg'
import sizeSmall from '../theme/icons/size-small.svg'
import sizeMedium from '../theme/icons/size-medium.svg'
import sizeLarge from '../theme/icons/size-large.svg'
import trash from '../theme/icons/trash.svg'

export const VideoPropertiesIcons = {
	optionControls,
	optionLoop,
	optionNoTracking,
	optionPlay,
	optionMute,
	positionAuto,
	positionLeft,
	positionRight,
	positionCenter,
	sizeSmall,
	sizeMedium,
	sizeLarge,
	trash
}
